import { OperationType } from "@/api/model";

/**
 * Operation types whose stitch type choice is restricted under the GSD V4 calculation engine:
 * Button Hole, Bartack and Button Sew. For every other operation type the choice is unchanged.
 */
const RESTRICTED_OPERATION_TYPES: ReadonlySet<OperationType> = new Set([
  OperationType.Bh,
  OperationType.Bt,
  OperationType.Bs
]);

/**
 * The only stitch types those restricted operation types may use. This list mirrors the server-side
 * set in `V4OperationHelper.AllowedStitchTypeCodesForRestrictedOperations`.
 */
export const ALLOWED_STITCH_TYPE_CODES: readonly string[] = ["101", "104", "107", "304", "404"];

/**
 * Returns true when the operation type / stitch type pair is not allowed under GSD V4, i.e. the operation
 * is a Button Hole, Bartack or Button Sew and its stitch type is outside the allowed list. An empty stitch
 * type is not reported here; the existing "please select a stitch type" check covers that.
 */
export function isInvalidOperationStitchType(
  operationType?: OperationType | null,
  stitchTypeCode?: string | null
): boolean {
  if (!operationType || !RESTRICTED_OPERATION_TYPES.has(operationType) || !stitchTypeCode) {
    return false;
  }
  // The form may carry the code with a "-description" suffix; compare on the base code only.
  const baseCode = stitchTypeCode.split("-")[0].trim();
  return !ALLOWED_STITCH_TYPE_CODES.includes(baseCode);
}
